import { combineReducers } from "redux";
import Auth from "./Auth";
import Theme from "./Theme";
import Lookup from "./Lookup";
const reducers = combineReducers({
  theme: Theme,
  auth: Auth,
  lookup: Lookup,
});

export default reducers;
